<template>
  <b-input-group
    :prepend="prependInput"
    :append="append"
  >
    <b-form-input
      v-model="internalValue"
      :type="inputType"
      :state="state"
      :accept="accept"
      :tabindex="tabindex"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :min="min"
      :max="max"
      :debounce="debounce"
      :size="size"
      :formatter="formattedValue"
      trim
      @input="handleInput"
      @blur="handleBlur"
      @update="value => $emit('update', value)"
    />
  </b-input-group>
</template>

<script>
export default {
  name: 'InputField',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    debounce: {
      type: [Number, String],
      default: 0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    prepend: {
      type: String,
      default: ''
    },
    append: {
      type: String,
      default: ''
    },
    formatter: {
      type: Function,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  computed: {
    inputType(){
      if (this.type === 'currency') {
        return 'text'
      }
      return this.type
    },
    prependInput() {
      return this.type === 'currency' ? '€' : this.prepend
    }
  },

  watch: {
    value: {
      handler(newValue) {
        this.internalValue = newValue
      },
    },
  },
  methods: {
    handleInput(value) {
      !this.disabled && this.$emit('input', value)
    },
    handleBlur(value) {
      !this.disabled && this.$emit('blur', value)
    },
    formattedValue(value) {
      if (this.type === 'currency') {
        return value.replace(/[^0-9,]/g, '')
      }
      return value
    }
  }
}
</script>

<style scoped lang="scss">

</style>
